import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'textToCopy',
    'copyBtn'
  ]

  copy() {
    navigator.clipboard.writeText(this.textToCopyTarget.textContent);

    this.copyBtnTarget.setAttribute('data-bs-original-title', 'Copié dans le presse-papier');

    const btnTooltip = bootstrap.Tooltip.getInstance(this.copyBtnTarget);
    btnTooltip.show();

    this.copyBtnTarget.setAttribute('data-bs-original-title', 'Copier');
  }
}
